const formatId = (prefix: string, value: string): string => {
  const formattedPrefix = prefix.trim().replace(/\s+/g, '_');
  const formattedValue = value.trim().replace(/\s+/g, '_');
  return `${formattedPrefix}\u003A${formattedValue}`;
};
export default formatId;
